module.exports = __webpack_public_path__ + "bf719cfaa4e9735e2305008798a1f970.svg";